import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function getPorNome (payload) {
  return sessaoFetchLoading(`consig`, `/configuracao_negocios/BuscarConfigPorChave`, 'PATCH', payload)
}

export async function getPorNomeCache (payload) {
  return sessaoFetchLoading('consig', `/configuracao_negocios/BuscarConfigPorChaveCache?` + serialize(payload))
}

export async function edit (payload) {
  return sessaoFetchLoading(`consig`, `/configuracao_negocios`, 'PUT', payload)
}

export async function alterarConfiguracao (payload) {
  return sessaoFetchLoading(`consig`, `/configuracao_negocios/LimiteDiarioCadastros`, 'PUT', payload)
}



// WEBPACK FOOTER //
// ./src/api/configuracao_negocios.js